// A selectable card, adapted from Isomorphic's multi-step form (shared/multi-step/multi-step-2):
// RizzUI's AdvancedRadio with a stronger ring and a check mark when chosen.
import { CheckCircle } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { AdvancedRadio } from "rizzui";

import { cn } from "../../../ui/cn";

export function ChoiceCard({
  name,
  value,
  checked,
  onSelect,
  icon,
  title,
  children,
  className,
}: {
  name: string;
  value: string;
  checked: boolean;
  onSelect: () => void;
  icon?: ReactNode;
  title: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <AdvancedRadio
      name={name}
      value={value}
      checked={checked}
      onChange={onSelect}
      className={cn("h-full", className)}
      rounded="lg"
      inputClassName="[&:checked~span]:ring-2 [&:checked~span]:bg-primary-lighter/40 [&:checked~span_.choice-check]:opacity-100 [&:focus-visible~span]:ring-2"
      contentClassName="relative flex h-full gap-3 !rounded-xl px-4 py-4 md:px-5"
    >
      {icon}
      <span className="min-w-0 flex-1 pe-6">
        <span className="block text-[15px] font-semibold text-gray-900">{title}</span>
        {children ? <span className="mt-1 block text-[13px] leading-snug text-gray-500">{children}</span> : null}
      </span>
      <CheckCircle weight="fill" aria-hidden className="choice-check absolute end-3 top-3 h-5 w-5 text-primary opacity-0 transition-opacity" />
    </AdvancedRadio>
  );
}
